import gql from 'graphql-tag'

export const FETCH_BRAZIL_TERRITORY = gql `
  query FetchBrazilTerritory {
    countries(limit: 1, page: 1) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_REGION = gql `
  query AsyncSelectByRegionsRegion($name: String!) {
    regionByName(name: $name) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_STATE = gql `
  query AsyncSelectByRegionsState($name: String!, $recgeoIds: [Int!]!) {
    statesByRecGeo(name: $name, recgeo_ids: $recgeoIds, limit: 10000, page: 1) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MESOREGION = gql `
  query AsyncSelectByRegionsMesoregion($name: String!, $recgeoIds: [Int!]!) {
    mesoregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MICROREGION = gql `
  query AsyncSelectByRegionsMicroregion($name: String!, $recgeoIds: [Int!]!) {
    microregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_CITY = gql `
  query AsyncSelectByRegionsCity($name: String!, $recgeoIds: [Int!]!) {
    citiesByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_BIOME = gql `
  query($name: String!) {
    biomesByName(name: $name) {
      id
      name: nome
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_CITY = gql `
  query($name: String!, $biomeIds: [Int!]!) {
    citiesByBiome(name: $name, biome_ids: $biomeIds, limit: 10000, page: 1) {
      id
      name: nome
      biomeName: bioma
    }
  }
`

export const QUERIES = {
    "country": FETCH_BRAZIL_TERRITORY,
    "regions_region": ASYNC_SELECT_BY_REGIONS_REGION,
    "regions_state": ASYNC_SELECT_BY_REGIONS_STATE,
    "regions_mesoregion": ASYNC_SELECT_BY_REGIONS_MESOREGION,
    "regions_microregion": ASYNC_SELECT_BY_REGIONS_MICROREGION,
    "regions_city": ASYNC_SELECT_BY_REGIONS_CITY,
    "biomes_biome": ASYNC_SELECT_BY_BIOMES_BIOME,
    "biomes_city": ASYNC_SELECT_BY_BIOMES_CITY,
    "regions_regions": ASYNC_SELECT_BY_REGIONS_REGION,
    "regions_states": ASYNC_SELECT_BY_REGIONS_STATE,
    "regions_mesoregions": ASYNC_SELECT_BY_REGIONS_MESOREGION,
    "regions_microregions": ASYNC_SELECT_BY_REGIONS_MICROREGION,
    "biomes_biomes": ASYNC_SELECT_BY_BIOMES_BIOME,
    "default": ASYNC_SELECT_BY_REGIONS_STATE
}



export function getTerritoryQuery(territoryType, searchTerritoryType) {
    if (searchTerritoryType === 'country') {
        return QUERIES[searchTerritoryType]

    } else {
        const key = territoryType + "_" + searchTerritoryType;
        return QUERIES[key] !== undefined ? QUERIES[key] : QUERIES["default"];
    }
}


// WEBPACK FOOTER //
// ./src/logic/TerritoryQueryUtils.js